import { clientStore } from 'apps/client/app';
import { routerStore } from 'core/routing';
import { isDesktopCompatibility } from 'hooks/useDesktopCompatible';
import { createTab, isInDesktopMode } from 'libs/gutClient/electronBridge';

export const navigateToFile = async (
  path: string,
  filename: string,
  hash: string,
  projectName: string,
) => {
  const params = {
    ...routerStore.route.params,
    basepath: path || null,
    contributionId: hash,
  };

  const toRouteName = `${clientStore.spaceRoute.route}.version.file`;

  const compatibleWithTab = await isDesktopCompatibility({
    feature: 'tab',
  });

  if (isInDesktopMode() && compatibleWithTab) {
    const dots = path.includes('/') ? '/...' : '';
    const tabTitle = `${projectName} ${dots} / ${filename}`;

    createTab(`${window.location.href}/${path}`, tabTitle, 'project-file', {
      routeName: toRouteName,
      options: params,
    });

    return;
  }

  routerStore.navigate(toRouteName, params);
};
